import React from "react";
import Countdown from "../Countdown";
import { getUserInfo } from "../../../../../services/AuthService";
import NetworkStatus from "./NetworkStatus";

const ExamInfoPanel = ({
  showInfoPanel,
  setShowInfoPanel,
  examData,
  assessmentId,
  handleSubmit,
  handleTimeUp,
  questions,
  current,
  currentMQ,
  questionsMQ,
  isQuestionAnswered,
  markedQuestions,
  handleNavFromPanel,
  doneCount,
  isCurrentQuestionMQ,
}) => {
  // Sử dụng helper function để check MQ
  const isMQQuestion = isCurrentQuestionMQ();

  // Hiển thị cho tất cả câu hỏi (bỏ logic return null)

  return (
    <>
      {/* Overlay để bắt sự kiện click bên ngoài */}
      {showInfoPanel && (
        <div
          className="fixed inset-0 bg-black bg-opacity-30 z-40"
          onClick={() => setShowInfoPanel(false)}
        ></div>
      )}

      {/* Info Panel */}
      <div
        className={`fixed top-0 right-0 bottom-0 w-full sm:w-[432px] bg-white shadow-lg border-l border-gray-200 overflow-y-auto transition-transform duration-300 z-50 ${
          showInfoPanel ? "translate-x-0" : "translate-x-full"
        }`}
      >
        <div className="p-4 h-full flex flex-col">
          {/* Header với nút đóng */}
          <div className="flex items-center justify-between mb-4">
            <h2 className="text-lg font-bold text-gray-800">
              Thông tin thí sinh
            </h2>
            <button
              onClick={() => setShowInfoPanel(false)}
              className="w-8 h-8 flex items-center justify-center rounded-full hover:bg-gray-100"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-5 w-5"
                viewBox="0 0 20 20"
                fill="currentColor"
              >
                <path
                  fillRule="evenodd"
                  d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                  clipRule="evenodd"
                />
              </svg>
            </button>
          </div>

          {/* Student Info */}
          <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-4 mb-4">
            <div className="flex items-center mb-3 sm:mb-4 justify-between">
              <span className="text-black text-xs sm:text-sm md:text-base">
                Họ tên:
              </span>
              <span className="text-black decoration-2 underline-offset-2 text-xs sm:text-sm md:text-base bg-gray-200 px-3 py-1 rounded-lg">
                {getUserInfo()?.username || "Vô danh"}
              </span>
            </div>
            <div className="flex items-center mb-3 sm:mb-4 justify-between">
              <span className="text-black text-xs sm:text-sm md:text-base">
                Mã dự thi:
              </span>
              <span className="text-black decoration-2 underline-offset-2 text-xs sm:text-sm md:text-base bg-gray-200 px-3 py-1 rounded-lg">
                {getUserInfo()?.identifier}
              </span>
            </div>
            <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between w-full gap-3 sm:gap-4">
              {/* <div className="flex items-center gap-2 min-w-0 flex-1">
                <span className="text-black text-xs sm:text-sm md:text-base whitespace-nowrap">
                  Thời gian còn lại
                </span>
                <Countdown
                  exam={examData}
                  onComplete={handleTimeUp}
                  assessmentId={assessmentId}
                  isTitle={false}
                />
              </div>
              <button
                onClick={handleSubmit}
                className="px-3 py-2 text-sm sm:text-base min-w-[80px] sm:min-w-[90px] whitespace-nowrap bg-[#cd1627] hover:bg-[#cd1627] focus:ring-[#cd1627] text-white hover:opacity-90 rounded-lg font-semibold transition-all duration-300 shadow-sm hover:shadow-md focus:outline-none focus:ring-2 focus:ring-offset-2 flex-shrink-0"
              >
                Nộp bài
              </button> */}
            </div>
          </div>

          {/* Question Grid */}
          <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-4 mb-4 flex-grow overflow-y-auto">
            <div className="mb-2 flex flex-col items-center">
              <span className="text-gray-500 text-sm font-medium">
                Danh sách câu hỏi
              </span>
              <div className="flex items-center gap-4 mt-2">
                <span className="text-xs text-gray-600 font-medium">
                  Chỉ thị màu sắc:
                </span>

                <div className="flex items-center gap-1">
                  <div className="w-6 aspect-square rounded-full bg-gray-300"></div>
                  <span className="text-xs text-gray-600">Chưa trả lời</span>
                </div>

                <div className="flex items-center gap-1">
                  <div className="w-6 aspect-square rounded-full bg-[#2563eb]"></div>
                  <span className="text-xs text-gray-600">Đã trả lời</span>
                </div>

                <div className="flex items-center gap-1">
                  <div className="w-6 aspect-square rounded-full bg-gray-200 border-2 border-[#f59e0b]"></div>
                  <span className="text-xs text-gray-600">Đánh dấu</span>
                </div>
              </div>
            </div>

            <div className="grid grid-cols-8 gap-1.5 mt-4">
              {questions.map((q, idx) => {
                // Xác định trạng thái của câu hỏi
                const questionNumber = parseInt(
                  q.question.match(/\d+/)?.[0] || "0"
                );
                const mqGroup = questionsMQ.find((e) =>
                  e?.range.includes(questionNumber)
                );

                // Logic xác định isCurrentQuestion
                let isCurrentQuestion = false;
                if (mqGroup) {
                  // Nếu là MQ question, check currentMQ
                  isCurrentQuestion = currentMQ === questionNumber;
                } else {
                  // Nếu không phải MQ, check current index
                  isCurrentQuestion = current === idx;
                }

                const isAnswered = isQuestionAnswered(q);
                const isMarked = markedQuestions.includes(idx);

                // Xác định class dựa trên trạng thái - ưu tiên isAnswered trước isMarked
                let buttonClass =
                  "w-8 h-8 rounded-full text-xs font-bold flex items-center justify-center transition-all duration-200 ";

                if (isAnswered && isMarked) {
                  // Đã trả lời VÀ đánh dấu (xanh dương + viền vàng)
                  buttonClass +=
                    "bg-[#2563eb] border-2 border-[#f59e0b] text-white hover:bg-[#1d4ed8]";
                  if (isCurrentQuestion) {
                    buttonClass +=
                      " ring-2 ring-white ring-offset-2 ring-offset-[#2563eb]";
                  }
                } else if (isAnswered) {
                  // Chỉ đã trả lời (xanh dương)
                  buttonClass += "bg-[#2563eb] text-white hover:bg-[#1d4ed8]";
                  if (isCurrentQuestion) {
                    buttonClass +=
                      " ring-2 ring-white ring-offset-2 ring-offset-[#2563eb]";
                  }
                } else if (isMarked) {
                  // Chỉ đánh dấu (viền vàng, nền xám)
                  buttonClass +=
                    "bg-gray-200 border-2 border-[#f59e0b] text-gray-700 hover:bg-gray-300";
                  if (isCurrentQuestion) {
                    buttonClass += " ring-2 ring-blue-500 ring-offset-2";
                  }
                } else {
                  // Chưa trả lời (xám)
                  buttonClass += "bg-gray-300 text-gray-600 hover:bg-gray-400";
                  if (isCurrentQuestion) {
                    buttonClass += " ring-2 ring-blue-500 ring-offset-2";
                  }
                }

                return (
                  <div key={idx}>
                    <button
                      className={buttonClass}
                      onClick={() => {
                        handleNavFromPanel(idx);
                        setShowInfoPanel(false);
                      }}
                      title={`Câu ${idx + 1}${
                        isMarked ? " (đã đánh dấu)" : ""
                      } - Nhấp đúp hoặc nhấp chuột phải để đánh dấu`}
                    >
                      {idx + 1}
                    </button>
                  </div>
                );
              })}
            </div>
          </div>

          {/* Progress */}
          <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-4 mb-4">
            <div className="flex items-center justify-between mb-3">
              <span className="text-gray-700 text-sm">Bạn đã hoàn thành</span>
              <span className="font-bold text-gray-800">
                {doneCount}/{questions.length}{" "}
                <span className="text-xs text-gray-500">câu</span>
              </span>
            </div>

            {/* Thanh tiến độ và % cùng dòng */}
            <div className="flex items-center gap-3 mb-3">
              <div className="flex-1 h-2 bg-gray-200 rounded-full overflow-hidden">
                <div
                  className="h-full bg-gradient-to-r from-green-400 to-green-500 rounded-full transition-all duration-500 ease-out"
                  style={{ width: `${(doneCount / questions.length) * 100}%` }}
                ></div>
              </div>
              <span className="text-sm font-bold text-green-600 min-w-[35px]">
                {Math.round((doneCount / questions.length) * 100)}%
              </span>
            </div>

            <NetworkStatus />
          </div>
        </div>
      </div>
    </>
  );
};

export default ExamInfoPanel;
